<template>
  <div>
    <div
      v-for="(template, index) in templates"
      :key="index">
      <template-box
        :active="template.display"
        :old-template="template"
        :template-index="index"
        :editable="editable"
        @save="templateSave($event, index)"
        @close="closeTemplateModal(index)" />
    </div>
    <v-col cols="12">
      <h4 class="field-header primary">
        Step 3 : วิธีการส่งข้อความ
      </h4>
    </v-col>
    <v-row>
      <v-col
        cols="12"
        md="10"
        offset-md="1"
        class="d-flex">
        <h4 class="mt-6 mr-6">
          Template :
        </h4>
        <div
          v-for="(msg, index) in templates"
          :key="index"
          class="message-box-wrap">
          <div
            class="input-message-box elevation-2"
            @click="openTemplateModal(index)">
            <span class="text-h3 font-weight-regular">{{ index+1 }}</span>
          </div>
          <div
            v-if="editable"
            class="remove-message-template-btn"
            @click="removeTemplate(index)">
            X
          </div>
        </div>
        <div
          v-if="templates.length < templatesLimit && editable"
          class="input-message-box elevation-2"
          @click="addTemplates">
          <span class="text-h3 font-weight-regular">+</span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import TemplateBox from './templates/TemplateBox.vue'

export default {
  components: {
    TemplateBox
  },
  props: {
    oldTemplates: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      templates: [],
      currentTemplate: 0,
      templatesLimit: 4,
      ready: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar',
      setModal: 'Style/setModal',
      setLoading: 'Style/setLoading'
    }),
    init () {
      this.templates = this.oldTemplates
      for (let i = 0; i < this.templates.length; i++) {
        this.templates[i].display = false
      }
      this.currentTemplate = this.templates.length - 1
    },
    addTemplates () {
      this.templates.push({
        templateIndex: -1,
        action: {
          action: '',
          more: {}
        },
        message: {
          type: [],
          text: '',
          img: [],
          itemInCart: [],
          carousel: []
        },
        frequency: {
          field: '',
          more: {}
        },
        display: true
      })
      this.currentTemplate = this.templates.length - 1

      this.returnValue()
    },
    openTemplateModal (index) {
      this.currentTemplate = index
      this.templates[index].display = true
      const temp = this.templates[index]
      this.templates.splice(index, 1, temp)
    },
    removeTemplate (index) {
      this.templates.splice(index, 1)
      this.currentTemplate = this.templates.length - 1
      this.returnValue()
    },
    closeTemplateModal (index) {
      this.templates[index].display = false
      const temp = this.templates[index]
      this.templates.splice(index, 1, temp)

      if (this.editable) {
        this.removeInvalidTemplate()
      }
    },
    templateSave (val, index) {
      this.templates[index].templateIndex = val.templateIndex
      this.templates[index].action = val.action
      this.templates[index].frequency = val.frequency
      this.templates[index].message = val.message

      this.closeTemplateModal(index)
      this.returnValue()
    },
    returnValue () {
      this.$emit('input', this.templates)
    },
    removeInvalidTemplate () {
      const invalidTemplates = this.templates.findIndex((template) => template.action.action === '')
      if (invalidTemplates !== -1) {
        this.templates.splice(invalidTemplates, 1)
      }
    }
  }
}
</script>

<style>
.errors-send-msg {
  position: absolute;
  color: #E53935;
}

.input-message-box {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 15px;
  /* border: 0.5px black solid; */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 4px;
}

.message-box-wrap {
  position: relative;
}

.remove-message-template-btn {
  font-size: 10px;
  position: absolute;
  width: 14px;
  height: 14px;
  color: white;
  background-color: black;
  text-align: center;
  cursor: pointer;
  right: 0px;
  top: 0px;
}

.error-message {
  font-size: 11px;
}

.upload-container {
  width: 20%;
  height: 168px;
}

.preview-container {
  width: 20%;
  height: 168px;
  position: relative;
}

.preview-container input {
  font-size: 12px;
}

.preview-container .img-container {
  display: flex;
  height: 98px;
}

.preview-container .img-preview {
  align-self: center;
  margin-bottom: 36px;
  width: 100%;
}

.preview-container .close-img-field-btn{
  font-size: 16px;
  position: absolute;
  width: 24px;
  height: 24px;
  color: white;
  background-color: black;
  text-align: center;
  cursor: pointer;
  right: 0px;
  top: 0px;
}

.img-row {
  width: 100%;
  margin-top: 32px;
  margin-left: 32px;
}

.field-header {
  text-align: center;
  padding: 8px;
  color: white;
  border-radius: 10px;
  width: 27%;
  font-size: 14px;
}
</style>
